import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEO from "@/components/SEO";
import { useLang } from "@/context/LanguageContext";
import { MessageCircle, Mail } from "lucide-react";
import { trackContact } from "@/lib/trackContact";

export default function About() {
  const { lang, t } = useLang();
  return (
    <div className="min-h-screen bg-xd-light">
      <SEO
        title={t("about_seo_title")}
        description={t("about_seo_desc")}
        path="/chi-siamo"
        lang={lang}
      />
      <Header />
      <section className="bg-xd-dark text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
          <div className="font-mono-tech text-xs uppercase tracking-widest text-xd-cyan">{t("about_kicker")}</div>
          <h1 className="font-display text-4xl font-semibold mt-2">{t("about_h1")}</h1>
          <p className="mt-4 text-slate-300 leading-relaxed max-w-2xl">
            {t("about_intro")}
          </p>
        </div>
      </section>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12 grid md:grid-cols-2 gap-6">
        <div className="bg-white border border-xd-border rounded-xl p-6">
          <div className="font-display text-lg font-semibold">{t("about_mission_title")}</div>
          <p className="text-sm text-xd-muted mt-2 leading-relaxed">{t("about_mission_desc")}</p>
        </div>
        <div className="bg-white border border-xd-border rounded-xl p-6">
          <div className="font-display text-lg font-semibold">{t("about_commit_title")}</div>
          <p className="text-sm text-xd-muted mt-2 leading-relaxed">{t("about_commit_desc")}</p>
        </div>
        <div className="md:col-span-2 flex gap-3 flex-wrap">
          <a href="https://wa.me/393511294525" target="_blank" rel="noreferrer" data-testid="about-whatsapp-btn" onClick={() => trackContact("whatsapp", "about")} className="btn-cta rounded-lg px-6 py-3 text-sm inline-flex items-center gap-2"><MessageCircle className="w-4 h-4" /> WhatsApp +39 351 129 4525</a>
          <a href="mailto:support@audrivio.com" data-testid="about-email-link" onClick={() => trackContact("email", "about")} className="rounded-lg px-6 py-3 text-sm border border-xd-border inline-flex items-center gap-2"><Mail className="w-4 h-4" /> support@audrivio.com</a>
        </div>
      </div>
      <Footer />
    </div>
  );
}
